{
  "labels": {
    "paste": "Постави",
    "pasteAsPlaintext": "Постави като обикновен текст",
    "pasteCharts": "Постави графики",
    "selectAll": "Маркирай всичко",
    "multiSelect": "Добави елемент към селекция",
    "moveCanvas": "Премести платно",
    "cut": "Изрежи",
    "copy": "Копирай",
    "copyAsPng": "Копиране в клипборда",
    "copyAsSvg": "Копирано в клипборда като SVG",
    "copyText": "",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Преместване напред",
    "sendToBack": "Изнасяне назад",
    "bringToFront": "Изнасяне отпред",
    "sendBackward": "Изпрати отзад",
    "delete": "Изтрий",
    "copyStyles": "Копирайте стилове",
    "pasteStyles": "Постави стилове",
    "stroke": "Щрих",
    "background": "Фон",
    "fill": "Наситеност",
    "strokeWidth": "Ширина на щриха",
    "strokeStyle": "Стил на линия",
    "strokeStyle_solid": "Плътен",
    "strokeStyle_dashed": "Пунктир",
    "strokeStyle_dotted": "Пунктирано",
    "sloppiness": "Небрежност",
    "opacity": "Прозрачност",
    "textAlign": "Подравняване на текста",
    "edges": "Крайща",
    "sharp": "Остър",
    "round": "Закръглено",
    "arrowheads": "Стрелки",
    "arrowhead_none": "Без",
    "arrowhead_arrow": "Стрелка",
    "arrowhead_bar": "Връх на стрелката",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Триъгълник",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Размер на шрифта",
    "fontFamily": "Семейство шрифтове",
    "addWatermark": "Добави \"Направено с Excalidraw\"",
    "handDrawn": "Нарисувано на ръка",
    "normal": "Нормален",
    "code": "Код",
    "small": "Малък",
    "medium": "Среден",
    "large": "Голям",
    "veryLarge": "Много голям",
    "solid": "Солиден",
    "hachure": "Хералдика",
    "zigzag": "Зигзаг",
    "crossHatch": "Двойно-пресечено",
    "thin": "Тънък",
    "bold": "Ясно очертан",
    "left": "Ляво",
    "center": "Център",
    "right": "Дясно",
    "extraBold": "Много ясно очертан",
    "architect": "Архитект",
    "artist": "Художник",
    "cartoonist": "Карикатурист",
    "fileTitle": "Име на файл",
    "colorPicker": "Избор на цвят",
    "canvasColors": "Използван на платно",
    "canvasBackground": "Фон на платно",
    "drawingCanvas": "Платно за рисуване",
    "layers": "Слоеве",
    "actions": "Действия",
    "language": "Език",
    "liveCollaboration": "",
    "duplicateSelection": "Дублирай",
    "untitled": "Неозаглавено",
    "name": "Име",
    "yourName": "Вашето име",
    "madeWithExcalidraw": "Направено с Excalidraw",
    "group": "Групирай селекцията",
    "ungroup": "Спри групирането на селекцията",
    "collaborators": "Сътрудници",
    "showGrid": "Показване на мрежа",
    "addToLibrary": "Добавяне към библиотеката",
    "removeFromLibrary": "Премахване от библиотеката",
    "libraryLoadingMessage": "Зареждане на библиотеката…",
    "libraries": "Разглеждане на библиотеките",
    "loadingScene": "Зареждане на сцена…",
    "align": "Подравняване",
    "alignTop": "Подравняване отгоре",
    "alignBottom": "Подравняване отдолу",
    "alignLeft": "Подравняване отляво",
    "alignRight": "Подравняване отдясно",
    "centerVertically": "Центрирай вертикално",
    "centerHorizontally": "Центрирай хоризонтално",
    "distributeHorizontally": "Разпредели хоризонтално",
    "distributeVertically": "Разпредели вертикално",
    "flipHorizontal": "Хоризонтално обръщане",
    "flipVertical": "Вертикално обръщане",
    "viewMode": "Изглед",
    "share": "Сподели",
    "showStroke": "",
    "showBackground": "",
    "toggleTheme": "Включи тема",
    "personalLib": "Лична Библиотека",
    "excalidrawLib": "Excalidraw Библиотека",
    "decreaseFontSize": "Намали размера на шрифта",
    "increaseFontSize": "Увеличи размера на шрифта",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "Редактирай линк",
      "editEmbed": "",
      "create": "",
      "createEmbed": "",
      "label": "Линк",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "",
      "exit": ""
    },
    "elementLock": {
      "lock": "Заключи",
      "unlock": "Отключи",
      "lockAll": "Заключи всички",
      "unlockAll": "Отключи всички"
    },
    "statusPublished": "Публикувани",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "Избери цвят от платното",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Няма добавени неща все още...",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": ""
  },
  "buttons": {
    "clearReset": "Нулиране на платно",
    "exportJSON": "",
    "exportImage": "",
    "export": "Запази на...",
    "copyToClipboard": "Копиране в клипборда",
    "save": "Запази към текущ файл",
    "saveAs": "Запиши като",
    "load": "Отвори",
    "getShareableLink": "Получаване на връзка за споделяне",
    "close": "Затвори",
    "selectLanguage": "Избор на език",
    "scrollBackToContent": "Превъртете обратно към съдържанието",
    "zoomIn": "Приближаване",
    "zoomOut": "Отдалечаване",
    "resetZoom": "Стандартен мащаб",
    "menu": "Меню",
    "done": "Завършено",
    "edit": "Редактиране",
    "undo": "Отмяна",
    "redo": "Повтори",
    "resetLibrary": "Нулиране на библиотеката",
    "createNewRoom": "Създай нова стая",
    "fullScreen": "На цял екран",
    "darkMode": "Тъмен режим",
    "lightMode": "Светъл режим",
    "zenMode": "Режим Zen",
    "objectsSnapMode": "",
    "exitZenMode": "Спиране на Zen режим",
    "cancel": "Отмени",
    "clear": "Изчисти",
    "remove": "Премахване",
    "embed": "",
    "publishLibrary": "Публикувай",
    "submit": "Изпрати",
    "confirm": "Потвърждаване",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Това ще изчисти цялото платно. Сигурни ли сте?",
    "couldNotCreateShareableLink": "Връзката не може да бъде създадена.",
    "couldNotCreateShareableLinkTooBig": "Не може да се създаде връзка за споделяне: сцената е твърде голяма",
    "couldNotLoadInvalidFile": "Невалиден файл не може да се зареди",
    "importBackendFailed": "Импортирането от бекенд не беше успешно.",
    "cannotExportEmptyCanvas": "Не може да се експортира празно платно.",
    "couldNotCopyToClipboard": "Не можем да копираме в клипбоарда.",
    "decryptFailed": "Данните не можаха да се дешифрират.",
    "uploadedSecurly": "Качването е защитено с криптиране от край до край, което означава, че сървърът Excalidraw и трети страни не могат да четат съдържанието.",
    "loadSceneOverridePrompt": "Зареждането на външна рисунка ще презапише настоящото ви съдържание. Желаете ли да продължите?",
    "collabStopOverridePrompt": "Прекратяването на сесията ще презапише предишната, локално запазена, рисунка. Сигурни ли сте?\n\n(Ако искате да продължите с локалната рисунка, просто затворете таба на браузъра.)",
    "errorAddingToLibrary": "Не можем да заредим от библиотеката",
    "errorRemovingFromLibrary": "Не можем да премахнем елемент от библиотеката",
    "confirmAddLibrary": "Ще се добавят {{numShapes}} фигура(и) във вашата библиотека. Сигурни ли сте?",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "Не може да бъде възстановена сцена от този файл",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "Изтрий {{count}} елемент(а) от библиотеката?",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": ""
  },
  "errors": {
    "unsupportedFileType": "Този файлов формат не се поддържа.",
    "imageInsertError": "",
    "fileTooBig": "Файлът е твърде голям. Максималния допустим размер е {{maxSize}}.",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "invalidSVGString": "Невалиден SVG.",
    "cannotResolveCollabServer": "",
    "importLibraryError": "Не можем да заредим библиотеката",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "Силно препоръчваме да изключите тази настройка. Можете да следвате <link>тези стъпки</link> за това как да го направите.",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Селекция",
    "image": "Вмъкване на изображение",
    "rectangle": "Правоъгълник",
    "diamond": "Диамант",
    "ellipse": "Елипс",
    "arrow": "Стрелка",
    "line": "Линия",
    "freedraw": "Рисуване",
    "text": "Текст",
    "library": "Библиотека",
    "lock": "Поддържайте избрания инструмент активен след рисуване",
    "penMode": "",
    "link": "",
    "eraser": "Гума",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "Още инструменти",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Действия по платното",
    "selectedShapeActions": "Избрани действия",
    "shapes": "Фигури"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "Кликнете, за да стартирате няколко точки, плъзнете за една линия",
    "freeDraw": "Натиснете и влачете, пуснете като сте готови",
    "text": "Подсказка: Можете също да добавите текст като натиснете някъде два път с инструмента за селекция",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "Кликнете върху последната точка или натиснете Escape или Enter, за да завършите",
    "lockAngle": "Можете да ограничите ъгъла, като задържите SHIFT",
    "resize": "Може да ограничите при преоразмеряване като задържите SHIFT,\nзадръжте ALT за преоразмерите през центъра",
    "resizeImage": "",
    "rotate": "Можете да ограничите ъглите, като държите SHIFT, докато се въртите",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "Натиснете Delete за да изтриете точка(и), CtrlOrCmd+D за дуплициране, или извлачете за да преместите",
    "lineEditor_nothingSelected": "",
    "placeImage": "",
    "publishLibrary": "",
    "bindTextToElement": "Натиснете Enter, за да добавите",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Невъзможност за показване на preview",
    "canvasTooBig": "Платното е твърде голямо.",
    "canvasTooBigTip": "Подсказка: пробвайте да приближите далечните елементи по-близко."
  },
  "errorSplash": {
    "headingMain": "Среща грешка. Опитайте <button>презареждане на страницата.</button>",
    "clearCanvasMessage": "Ако презареждането не работи, опитайте <button>изчистване на платното.</button>",
    "clearCanvasCaveat": " Това ще доведе до загуба на работа ",
    "trackedToSentry": "Грешката с идентификатор {{eventId}} беше проследен в нашата система.",
    "openIssueMessage": "Бяхме много предпазливи да не включите информацията за вашата сцена при грешката. Ако сцената ви не е частна, моля, помислете за последващи действия на нашата <button>тракер за грешки.</button> Моля, включете информация по-долу, като я копирате и добавите в GitHub.",
    "sceneContent": "Съдържание на сцената:"
  },
  "roomDialog": {
    "desc_intro": "Можете да поканите хора на текущата си сцена да си сътрудничат с вас.",
    "desc_privacy": "Не се притеснявайте, сесията използва криптиране от край до край, така че каквото нарисувате ще остане частно. Дори нашият сървър няма да може да види какво предлагате.",
    "button_startSession": "Стартирайте сесията",
    "button_stopSession": "Стоп на сесията",
    "desc_inProgressIntro": "Сесията за сътрудничество на живо е в ход.",
    "desc_shareLink": "Споделете тази връзка с всеки, с когото искате да си сътрудничите:",
    "desc_exitSession": "Спирането на сесията ще ви изключи от стаята, но ще можете да продължите да работите със сцената, локално. Имайте предвид, че това няма да засегне други хора и те все още ще могат да си сътрудничат с тяхната версия.",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "Грешка"
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "Експорт",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "Прочетете нашия блог",
    "click": "клик",
    "deepSelect": "",
    "deepBoxSelect": "",
    "curvedArrow": "Извита стрелка",
    "curvedLine": "Извита линия",
    "documentation": "Документация",
    "doubleClick": "двойно-щракване",
    "drag": "плъзнете",
    "editor": "Редактор",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Намерихте проблем? Изпратете",
    "howto": "Следвайте нашите ръководства",
    "or": "или",
    "preventBinding": "Спри прилепяне на стрелките",
    "tools": "Инструменти",
    "shortcuts": "Клавиши за бърз достъп",
    "textFinish": "Завърши редактиране (текстов редактор)",
    "textNewLine": "Добави нова линия (текстов редактор)",
    "title": "Помощ",
    "view": "Преглед",
    "zoomToFit": "Приближи докато се виждат всички елементи",
    "zoomToSelection": "Приближи селекцията",
    "toggleElementLock": "Заключи/Отключи селекция",
    "movePageUpDown": "Премести страница нагоре/надолу",
    "movePageLeftRight": "Премести страница наляво/надясно"
  },
  "clearCanvasDialog": {
    "title": "Изчисти платното"
  },
  "publishDialog": {
    "title": "Публикувай библиотека",
    "itemName": "Име",
    "authorName": "Авторско име",
    "githubUsername": "GitHub потребителско име",
    "twitterUsername": "Twitter потребителско име",
    "libraryName": "Име на библиотеката",
    "libraryDesc": "Описание на библиотеката",
    "website": "Уебсайт",
    "placeholder": {
      "authorName": "Името или потребителското Ви име",
      "libraryName": "Име на библиотеката Ви",
      "libraryDesc": "Описание на библиотеката ви, за да помогнете на хората да разберат приложенията ѝ",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "Задължително",
      "website": "Въведете валиден URL адрес"
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "Нулирай библиотека",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "Фон",
      "onlySelected": "Само избраното",
      "darkMode": "Тъмен режим",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "Изнасяне в PNG",
      "exportToSvg": "Изнасяне в SVG",
      "copyPngToClipboard": "Копирай PNG в клипборда"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Копиране в клипборда"
    }
  },
  "encrypted": {
    "tooltip": "Вашите рисунки са криптирани от край до край, така че сървърите на Excalidraw няма да могат да ги виждат.",
    "link": ""
  },
  "stats": {
    "angle": "Ъгъл",
    "element": "Елемент",
    "elements": "Елементи",
    "height": "Височина",
    "scene": "Сцена",
    "selected": "Селектирано",
    "storage": "Съхранение на данни",
    "title": "Статистика за хакери",
    "total": "Общо",
    "version": "Версия",
    "versionCopy": "Настисни за да копираш",
    "versionNotAvailable": "Версията не е налична",
    "width": "Широчина"
  },
  "toast": {
    "addedToLibrary": "Добавена към библиотеката",
    "copyStyles": "Копирани стилове.",
    "copyToClipboard": "Копирано в клипборда.",
    "copyToClipboardAsPng": "Копира {{exportSelection}} в клипборда като PNG\n({{exportColorScheme}})",
    "fileSaved": "Файлът е запазен.",
    "fileSavedToFilename": "Запазен към {filename}",
    "canvas": "платно",
    "selection": "селекция",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Прозрачен",
    "black": "Черен",
    "white": "Бял",
    "red": "Червен",
    "pink": "Розов",
    "grape": "Грозде",
    "violet": "Виолетово",
    "gray": "Сив",
    "blue": "Син",
    "cyan": "Синьозелено",
    "teal": "Тъмно синьо-зелено",
    "green": "Зелено",
    "yellow": "Жълто",
    "orange": "Оранжево",
    "bronze": "Бронзово"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Всичките Ви данни са запазени локално в браузъра Ви.",
      "center_heading_plus": "",
      "menuHint": "Експорт, предпочитания, езици, ..."
    },
    "defaults": {
      "menuHint": "Експорт, предпочитания, и още...",
      "center_heading": "Диаграми. Направени. Просто.",
      "toolbarHint": "Изберете инструмент & Започнете да рисувате!",
      "helpHint": "Преки пътища & помощ"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Най-често използвани цветове",
    "colors": "Цветове",
    "shades": "Нюанси",
    "hexCode": "Шестнадесетичен код",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Изнеси като изображение",
        "button": "Изнеси като изображение",
        "description": ""
      },
      "saveToDisk": {
        "title": "Запази към диск",
        "button": "Запази към диск",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Експортирай към Excalidraw+",
        "description": "Запази сцената към Excalidraw+ работното място."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Зареди от файл",
        "button": "Зареди от файл",
        "description": ""
      },
      "shareableLink": {
        "title": "Зареди от линк",
        "button": "Замени моето съдържание",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
